import { CommunicationContent } from "@/components/communications/CommunicationContent.tsx";
import {
  MainContentWrapper,
  SiteHeaderContent,
  ViewWrapper,
} from "@/components/layout/ViewWrapper.tsx";
import { Loader } from "@/components/loader/Loader.tsx";
import { useCommunication } from "@/hooks/useCommunication.ts";
import { useRoute } from "wouter";

export const CommunicationDetail = () => {
  const [, params] = useRoute("/communications/:id");
  const id = params?.id;

  const { communication: data, isLoading } = useCommunication({ id });

  const title = data?.channel === "text" ? "Message" : "Email";

  return (
    <ViewWrapper headerContent={<SiteHeaderContent includeBackButton title={title} />}>
      <MainContentWrapper>
        {isLoading && !data ? (
          <Loader className="py-8" />
        ) : data ? (
          <CommunicationContent data={data} showAgentComposer />
        ) : (
          <p className="text-muted-foreground text-sm p-4">Message not found.</p>
        )}
      </MainContentWrapper>
    </ViewWrapper>
  );
};
